import type { CSSProperties, ReactNode } from 'react';
import styles from './Steve.module.css';

interface Props {
  /** Durée de l'animation de flottement, propre à chaque skin. */
  readonly bobDuration: string;
  /** Rendu en bouton quand il est cliquable, pour rester utilisable au clavier. */
  readonly onClick?: () => void;
  /** Texte lu par les lecteurs d'écran à la place du dessin. */
  readonly label?: string;
}

/**
 * Le dessin de Steve, identique dans les trois skins. Seules la durée du
 * flottement et deux couleurs (pupille, densité de l'ombre) varient, via des
 * variables CSS posées par le skin.
 */
export function Steve({ bobDuration, onClick, label }: Props): ReactNode {
  const style = { '--bob-duration': bobDuration } as CSSProperties;

  const parts = (
    <>
      <span className={`${styles.part} ${styles.armBack}`} />
      <span className={`${styles.part} ${styles.tail}`} />
      <span className={`${styles.part} ${styles.body}`} />
      <span className={`${styles.part} ${styles.eye}`}>
        <span className={styles.pupil} />
      </span>
      <span className={`${styles.part} ${styles.armFront}`} />
      <span className={`${styles.part} ${styles.leg} ${styles.legLeft}`} />
      <span className={`${styles.part} ${styles.leg} ${styles.legRight}`} />
      <span className={`${styles.part} ${styles.foot} ${styles.footLeft}`} />
      <span className={`${styles.part} ${styles.foot} ${styles.footRight}`} />
    </>
  );

  if (!onClick) {
    return (
      <div className={styles.steve} style={style} aria-hidden="true">
        {parts}
      </div>
    );
  }

  return (
    <button
      type="button"
      className={`${styles.steve} ${styles.clickable}`}
      style={style}
      onClick={onClick}
      aria-label={label}
    >
      {parts}
    </button>
  );
}
